<template>
    <div id="bar2" class="line" style="width:100%;height:100%;"></div>
</template>
<script>
import * as echarts from 'echarts';
export default{
    props: {
        data: {
            type: Object,
            default: (()=>{
                return {}
            })
        },
    },
    data(){
        return{
            chart:null
        }
    },
    mounted() {
        // this.initChart()
    },
    beforeDestroy() {
        if (!this.chart) {
        return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            var _this = this
            this.chart = echarts.init(document.getElementById('bar2'))
            console.log(this.data)
            var option = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    top:'10%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis'
                },  
                legend: {
                    data: _this.data.xData
                },
                xAxis: {
                    type: 'category',
                    data: _this.data.xData
                },
                yAxis: {
                    type: 'value'
                },
                series: _this.data.yData
            };
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                if (this.chart) {
                    this.chart.resize()
                }
            })
        }
    }
}
</script>